import videojs from 'video.js';
import store from 'store';
const KEY = 'persistPlaybackRate';
export function persist(player, key) {
    const playbackRate = player.playbackRate();
    const data = store.get(KEY, {});
    data[key] = playbackRate;
    store.set(KEY, data);
}
export function restore(player, key) {
    const data = store.get(KEY, {});
    const rate = data[key] || 1;
    player.playbackRate(rate);
}
videojs.registerPlugin('persistPlaybackRate', function (options) {
    this.ready(function () {
        const player = this;
        player.on('loadedmetadata', function () {
            restore(player, options.key);
            const update = () => {
                persist(player, options.key);
            };
            player.on('ratechange', update);
            player.one('dispose', () => {
                player.off('ratechange', update);
            });
        });
    });
});
export default KEY;
